import React, { useContext } from "react";
import { Card, Placeholder } from "react-bootstrap";
import "./DashBoard.css";
import AuthContext from "../../context/user-auth/AuthProvider";
import BlockLoader from "../../component/blockloader/BlockLoader";

const applicationLogos = {
  "DCT Website": `<div class="dashboard_mainIcon text-center mb-4">
  <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" fill="#3e4aff" class="bi bi-cart3" viewBox="0 0 16 16">
  <path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM3.102 4l.84 4.479 9.144-.459L13.89 4H3.102zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
</svg>
</div>`,
"DCT Website Punch-In": `<div class="dashboard_mainIcon text-center mb-4">
<svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" fill="#fe696a" viewBox="0 0 576 512"><path d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H69.5c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H199.7c-11.5 0-21.4-8.2-23.6-19.5L170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32H360V134.1l23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23V32H120.1C111 12.8 91.6 0 69.5 0H24zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"/></svg>
</div>`,
  "DCT Tracker": `<div class="dashboard_mainIcon text-center mb-4">
  <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" fill="#55b157" class="bi bi-graph-up-arrow" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M0 0h1v15h15v1H0V0Zm10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V4.9l-3.613 4.417a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61L13.445 4H10.5a.5.5 0 0 1-.5-.5Z"/>
</svg>
</div>`,
  "DCT SLA": `<div class="dashboard_mainIcon text-center mb-4">
  <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" fill="#cd3232" class="bi bi-journal-text" viewBox="0 0 16 16">
  <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
  <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2z"/>
  <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H1z"/>
</svg>
</div>`,
  "DCT Gdocs": `<div class="dashboard_mainIcon text-center mb-4">
  <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" fill="#0e9eec" class="bi bi-table" viewBox="0 0 16 16">
  <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm15 2h-4v3h4V4zm0 4h-4v3h4V8zm0 4h-4v3h3a1 1 0 0 0 1-1v-2zm-5 3v-3H6v3h4zm-5 0v-3H1v2a1 1 0 0 0 1 1h3zm-4-4h4V8H1v3zm0-4h4V4H1v3zm5-3v3h4V4H6zm4 4H6v3h4V8z"/>
</svg>
</div>`,
  "DCT Edocs": `<div class="dashboard_mainIcon text-center mb-4">
  <svg xmlns="http://www.w3.org/2000/svg" width="80px" heigth="80px" viewBox="0 0 512 512">
    <path fill="#2748a3" d="M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z" />
  </svg>
</div>`,
"DCT Customer Portal": `<div class="dashboard_mainIcon text-center mb-4">
<svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" fill="#061b8d" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
  <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"/>
</svg>
</div>`,
};

const DashBoard = () => {
  const { applicationIds } = useContext(AuthContext);

  return (
    <>
      {applicationIds.length>0 ?(
        <div className="container">
          <div className="row systemManagement">
            {
              (
                applicationIds.map((list) => {
                  return (
                    <div className="col-lg-4 d-table" key={list.name}>
                      <Card className="d-table-cell">
                        <a href={`${list.url}`}>
                          <Card.Header className="fs-4 fw-bold">{list.name}</Card.Header>
                          {list.name === "DCT Admin" ? (
                            <div className="dashboard_mainIcon text-center mb-4">
                              <svg xmlns="http://www.w3.org/2000/svg" width="90px" height="90px" fill="currentColor" class="bi bi-person-gear" viewBox="0 0 16 16">
                                <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.256 7a4.474 4.474 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10c.26 0 .507.009.74.025.226-.341.496-.65.804-.918C9.077 9.038 8.564 9 8 9c-5 0-6 3-6 4s1 1 1 1h5.256Zm3.63-4.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382l.045-.148ZM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
                              </svg>
                            </div>
                          ) : (
                            <Card.Body dangerouslySetInnerHTML={{ __html: applicationLogos[list.name] }}></Card.Body>
                          )}
                        </a>
                      </Card>
                    </div>
                  );
                })
              )
            }
            {/* <Card>
              <Card.Header className="fs-4 fw-bold">E-Docs</Card.Header>
              <Card.Body>
                <div className="dashboard_mainIcon text-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80px" heigth="80px" viewBox="0 0 512 512">
                    <path fill="#2748a3" d="M64 256V160H224v96H64zm0 64H224v96H64V320zm224 96V320H448v96H288zM448 256H288V160H448v96zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z" />
                  </svg>
                </div>
                <div className="dashboard_icon d-flex align-items-center justify-content-between">
                  <svg id="graph" xmlns="http://www.w3.org/2000/svg" width="60px" heigth="60px" viewBox="0 0 512 512">
                    <path fill="#108610" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
                  </svg>
                  <svg id="circle" xmlns="http://www.w3.org/2000/svg" width="40px" heigth="40px" viewBox="0 0 576 512">
                    <path fill="#f11919" d="M304 240V16.6c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16H304zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4V288L412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288H558.4z" />
                  </svg>
                  <svg id="cal" xmlns="http://www.w3.org/2000/svg" width="40px" heigth="40px" viewBox="0 0 512 512">
                    <path
                      fill="#d18d0f"
                      d="M272 288h-64C163.8 288 128 323.8 128 368C128 376.8 135.2 384 144 384h192c8.836 0 16-7.164 16-16C352 323.8 316.2 288 272 288zM240 256c35.35 0 64-28.65 64-64s-28.65-64-64-64c-35.34 0-64 28.65-64 64S204.7 256 240 256zM496 320H480v96h16c8.836 0 16-7.164 16-16v-64C512 327.2 504.8 320 496 320zM496 64H480v96h16C504.8 160 512 152.8 512 144v-64C512 71.16 504.8 64 496 64zM496 192H480v96h16C504.8 288 512 280.8 512 272v-64C512 199.2 504.8 192 496 192zM384 0H96C60.65 0 32 28.65 32 64v384c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64V64C448 28.65 419.3 0 384 0zM400 448c0 8.836-7.164 16-16 16H96c-8.836 0-16-7.164-16-16V64c0-8.838 7.164-16 16-16h288c8.836 0 16 7.162 16 16V448z"
                    />
                  </svg>
                </div>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header className="fs-4 fw-bold">DCT Tracker</Card.Header>
              <Card.Body>
                <div className="dashboard_mainIcon text-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80px" heigth="80px" viewBox="0 0 512 512">
                    <path fill="#108610" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
                  </svg>
                </div>
                <div className="dashboard_stats text-center">
                  <h2 className="fw-bold">
                    $25.24 <sub>M</sub>
                    <sup>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15px" heigth="15px" viewBox="0 0 384 512">
                        <path fill="#108610" d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
                      </svg>
                    </sup>
                  </h2>
                </div>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header className="fs-4 fw-bold">SLA Analysis</Card.Header>
              <Card.Body>
                <div className="dashboard_mainIcon text-center mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="80px" heigth="80px" viewBox="0 0 512 512">
                    <path fill="#108610" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
                  </svg>
                </div>
                <div className="dashboard_stats text-center">
                  <h2 className="fw-bold text-success">
                    90.25 <sub>%</sub>
                    <sup>
                      <svg xmlns="http://www.w3.org/2000/svg" width="15px" heigth="15px" viewBox="0 0 384 512">
                        <path fill="#108610" d="M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.2V448c0 17.7 14.3 32 32 32s32-14.3 32-32V141.2L329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z" />
                      </svg>
                    </sup>
                  </h2>
                </div>
              </Card.Body>
            </Card>

            <Card>
              <Card.Header className="fs-4 fw-bold">Website</Card.Header>
              <Card.Body>
                <div className="dashboard_mainIcon text-center mb-4" to={`/redirect/http://localhost:3000/`}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="80px" heigth="80px" viewBox="0 0 512 512">
                    <path fill="#108610" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z" />
                  </svg>
                </div>
              </Card.Body>
            </Card>

            <Card>
              <Link to={"/admin"} style={{ textDecoration: "none" }}>
                <Card.Header className="fs-4 fw-bold">Admin</Card.Header>
                <Card.Body>
                  <div className="dashboard_mainIcon text-center mb-4">
                    <AdminPanelSettingsIcon fontSize="large" color="primary" />
                  </div>
                </Card.Body>
              </Link>
            </Card> */}
          </div>
        </div>):(
          <>
            <BlockLoader position="fixed" />
            <div className="row">
              {
                new Array(6).fill("").map((item, index) => (
                  <div className="col-4">
                    <Card key={item} style={{ minHeight: "217px" }}>
                      <Card.Header className="fs-4 fw-bold">
                        <Placeholder as={Card.Title} animation="glow">
                          <Placeholder xs={6} />
                        </Placeholder>
                      </Card.Header>
                      <Card.Body>
                        <Placeholder as={Card.Title} animation="glow">
                          <Placeholder xs={6} />
                        </Placeholder>
                        <Placeholder as={Card.Text} animation="glow">
                          <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} /> <Placeholder xs={6} /> <Placeholder xs={8} />
                        </Placeholder>
                      </Card.Body>
                    </Card>
                  </div>
                ))
              }
            </div>
          </>
        )
      }
    </>
  );
};

export default DashBoard;
